import { Flex, Stack, Table } from "@mantine/core";
import dayjs                  from "dayjs";
import { useRouter }          from "next/router";
import { useState }           from "react";

import { checkIsBrowser } from "_common/utils";
import ConfirmationModal  from "_components/atoms/confirmationModal";
import Image              from "_components/atoms/image";
import Typography         from "_components/atoms/typography";

import useStyles from "./styles";

const FAILED = "FAILED";

const DonationSuccessModal = ( { donationDetails, streamerDetails } ) => {
	const router                = useRouter ();
	const { classes }           = useStyles ( undefined, { name: "donationSuccessModal" } );
	const [ opened, setOpened ] = useState ( Object.keys ( donationDetails ).length > 0 );

	const donorDetails = donationDetails?.donorDetails && JSON.parse ( donationDetails?.donorDetails );

	const createLink = () => {
		const host = window.location.host;

		return `${ host }${ router.pathname }?moneyDonationId=${ donationDetails.id }&moneyDonationKey=${ donationDetails.moneyDonationKey }`;
	};

	return (
		<ConfirmationModal
			closeOnClickOutside = { false }
			closeOnEscape       = { false }
			content             = { (
				<Stack
					align = "center"
					my    = "md"
				>
					<Flex
						align     = "center"
						className = { classes.nameContainer }
						gap       = "1rem"
					>
						<Image
							className = { classes.avatar }
							src       = { streamerDetails?.photo }
							type      = "mdpi"
						/>

						<Typography
							title  = { streamerDetails?.name }
							weight = "500"
						/>

					</Flex>

					<Typography
						dimmed
						size   = "sm"
						title  = { dayjs ( donationDetails?.paytmTxnDate ).format ( "hh:mm A, DD MMMM YYYY" ) }
						weight = "500"
					/>

					<Typography
						dimmed
						size  = "sm"
						title = "Use this link for future reference"
					/>

					<Flex gap = "sm">

						<Typography
							dimmed
							linkify
							maw   = "400px"
							mb    = "md"
							size  = "sm"
							style = { { wordBreak: "break-word" } }
							ta    = "center"
							title = { checkIsBrowser () ? createLink () : "" }

						/>

					</Flex>

					<Table
						m   = "1rem"
						maw = "400px"
					>
						<tr>
							<td>
								<Typography
									size   = "sm"
									title  = "Donated By"
									weight = "500"
								/>
							</td>

							<td>
								<Typography
									size  = "sm"
									title = { donorDetails?.name }
								/>
							</td>

						</tr>

						<tr>
							<td>
								<Typography
									size   = "sm"
									title  = "Message"
									weight = "500"
								/>
							</td>

							<td>
								<Typography
									size  = "sm"
									title = { donorDetails?.comment }
								/>
							</td>

						</tr>

						<tr>
							<td>
								<Typography
									size   = "sm"
									title  = "Transaction ID"
									weight = "500"
								/>
							</td>

							<td>
								<Typography
									size  = "sm"
									style = { { wordBreak: "break-word" } }
									title = { donationDetails?.paytmTxnId }
								/>
							</td>

						</tr>

						{/* </thead> */}

						{/* <tbody> */}
						{/* {rows} */}
						{/* </tbody> */}
					</Table>

				</Stack>
			) }
			icon                = { donationDetails?.status === FAILED ? "errorAlert" : "tickFilled" }
			opened              = { opened }
			primaryCtaText      = { "Donate Again" }
			secondaryCtaText    = { "Close" }
			setOpened           = { setOpened }
			title               = { donationDetails?.status === FAILED ? "Donation Unsuccessful" : "Successfully Donated to" }
			withCloseButton     = { false }
		/>
	);
};

export default DonationSuccessModal;
